import { render } from "./PhotoCards.vue?vue&type=template&id=3a99b60a"
import script from "./PhotoCards.vue?vue&type=script&lang=js"
export * from "./PhotoCards.vue?vue&type=script&lang=js"

import "./PhotoCards.vue?vue&type=style&index=0&id=3a99b60a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__